import api from '../api/axiosConfig';

export const analyticsApi = {
    // Получить отчет по вакансии
    getVacancyReport: async (vacancyId, asOfDate = null) => {
        try {
            const params = { vacancy_id: vacancyId };
            if (asOfDate) {
                params.as_of_date = asOfDate;
            }
            const response = await api.get(`/analytics/vacancy-report`, {
                params,
                loadingMessage: 'Получение отчёта...',
                successMessage: 'Отчёт успешно получен'
            });
            return response.data.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Экспортировать отчет по вакансии в Excel
    exportVacancyReportToExcel: async (vacancyId) => {
        try {
            const response = await api.get(`/analytics/vacancy-report/export.xlsx`, {
                params: { vacancy_id: vacancyId },
                responseType: 'blob', // Важно для получения файла
                loadingMessage: 'Экспорт отчёта...',
                successMessage: 'Отчёт успешно экспортирован'
            });

            // Создаем ссылку для скачивания файла
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `vacancy_report_${vacancyId}_${new Date().getTime()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    // Получить отчет по рекрутеру
    getRecruiterReport: async (params) => {
        try {
            // params должен содержать:
            // period_start, period_end, org_ids[], department_ids[], recruiter_ids[]
            const response = await api.get(`/analytics/recruiters-report`, {
                params,
                loadingMessage: 'Получение отчёта по рекрутерам...',
                successMessage: 'Отчёт успешно получен',
                paramsSerializer: (params) => {
                    const parts = [];
                    Object.keys(params).forEach(key => {
                        const value = params[key];
                        if (Array.isArray(value)) {
                            value.forEach(v => {
                                const numValue = Number(v);
                                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(numValue)}`);
                            });
                        } else if (value !== null && value !== undefined) {
                            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                        }
                    });
                    return parts.join('&');
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    exportRecruiterReportToExcel: async (params) => {
        try {
            const response = await api.get(`/analytics/recruiters-report/export.xlsx`, {
                params,
                responseType: 'blob',
                loadingMessage: 'Экспорт отчёта по рекрутерам...',
                successMessage: 'Отчёт успешно экспортирован',
                paramsSerializer: (params) => {
                    const parts = [];
                    Object.keys(params).forEach(key => {
                        const value = params[key];
                        if (Array.isArray(value)) {
                            value.forEach(v => {
                                const numValue = Number(v);
                                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(numValue)}`);
                            });
                        } else if (value !== null && value !== undefined) {
                            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                        }
                    });
                    return parts.join('&');
                }
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `recruiter_report_${new Date().getTime()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    }
};

